import React from "react";
import * as styles from "./TextSectionNews.module.scss";

const TextSectionNews = ({ newsText }) => {
  return (
    <section className={`${styles.procedureDetailContainer} flex`}>
      <div className="container m0-auto">
        <div className={styles.procedureDetail}>
          <div className={styles.stepsContainer}>
            <div dangerouslySetInnerHTML={{ __html: newsText }} />
          </div>

          <div className={styles.container_info}>
            <div className={styles.container_info_text}>
              <h4>Zona Clientes</h4>
              <p>
                Entrá a nuestra sección Soporte y encontrá todo lo que
                necesitás. Servicio Técnica, Manuales, Preguntas Frecuentes y
                mucho más.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default TextSectionNews;
